import React from 'react';
import {
  Button, Col, Modal, Row, Table,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsArrowRepeat, BsDownload } from 'react-icons/bs';
import { ProcessDocumentItem } from 'types/Process';

type ProcessDocumentsModalProps = {
  show: boolean
  onClose: () => void
  isLoading: boolean
  files: ProcessDocumentItem[]
  onDownload: ( fileName: string ) => void
  onRegeneratePdfDownload: ( fileName: string ) => void
};

function ProcessDocumentsModal( {
  show,
  onClose,
  isLoading,
  files,
  onDownload,
  onRegeneratePdfDownload,
}: ProcessDocumentsModalProps ) {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      centered
      size="lg"
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4">
              {t( 'admin.processes.documentsTitle' )}
            </h3>
            <div>
              <div className="mt-3 px-3">
                {isLoading && (
                  <p className="mb-0">{t( 'admin.processes.loadingDocuments' )}</p>
                )}
                {!isLoading && files.length === 0 && (
                  <p className="mb-0 text-muted">{t( 'admin.processes.noDocuments' )}</p>
                )}
                {!isLoading && files.length > 0 && (
                  <Table responsive hover className="mb-0">
                    <thead>
                      <tr>
                        <th />
                        <th className="text-end" />
                        <th className="text-end" />
                      </tr>
                    </thead>
                    <tbody>
                      {files.map( ( file ) => (
                        <tr key={file.fileName}>
                          <td>{file.fileName}</td>
                          <td className="text-end">
                            <Button
                              variant="link"
                              className="p-0"
                              title={t( 'admin.common.download' )}
                              aria-label={t( 'admin.common.download' )}
                              onClick={() => onDownload( file.fileName )}
                            >
                              <BsDownload />
                            </Button>
                          </td>
                          <td className="text-end">
                            <Button
                              variant="link"
                              className="p-0"
                              title={t( 'admin.processes.regeneratePdfDownload' )}
                              aria-label={t( 'admin.processes.regeneratePdfDownload' )}
                              onClick={() => onRegeneratePdfDownload( file.fileName )}
                            >
                              <BsArrowRepeat className="text-primary" />
                            </Button>
                          </td>
                        </tr>
                      ) )}
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
            <Button
              variant="primary"
              type="button"
              className="btn--full-width mt-4"
              onClick={onClose}
            >
              {t( 'close' )}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default ProcessDocumentsModal;
